module.exports = __webpack_public_path__ + "img/阳台mini.dc077ab5.webp";